module.exports = __webpack_public_path__ + "static/media/NewDocEdit.7103d1bb.svg";